import { store } from "../../../..";
import { updateWebAutomation } from "../webAutomationSlice";

const initialPlaywrightCSharpReqNRollState = {
  testCases: [],
  automationType: "",
  automationPath: "",
  featureFiles: "",
  pageDOM: "",
  locators: {},
  pageClass: [],
  uploadedTestData: null,
  stepDefinition: [],
  projectData: {},
  currentStep: "",
  isLoading: false,
  error: null,
};

function getUpdatedPlaywrightCSharpReqNRollState(locationKey, key, value) {
  const state = store.getState();

  const currentAutomationPreferences = state["testAutomation"][locationKey]["webAutomation"]["playwrightCSharpReqNRoll"];

  return { ...currentAutomationPreferences, [key]: value };
}

export const createPlaywrightCSharpReqNRoll = (locationKey) => updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", initialPlaywrightCSharpReqNRollState);

export const setTestCasesState = (locationKey, data) => {
  const updatedPlaywrightCSharpReqNRoll = getUpdatedPlaywrightCSharpReqNRollState(locationKey, "testCases", data);

  return updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", updatedPlaywrightCSharpReqNRoll);
}

export const setAutomationTypeState = (locationKey, data) => {
  const updatedPlaywrightCSharpReqNRoll = getUpdatedPlaywrightCSharpReqNRollState(locationKey, "automationType", data);

  return updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", updatedPlaywrightCSharpReqNRoll);
}

export const setAutomationPathState = (locationKey, data) => {
  const updatedPlaywrightCSharpReqNRoll = getUpdatedPlaywrightCSharpReqNRollState(locationKey, "automationPath", data);

  return updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", updatedPlaywrightCSharpReqNRoll);
}

export const setFeatureFilesState = (locationKey, data) => {
  const updatedPlaywrightCSharpReqNRoll = getUpdatedPlaywrightCSharpReqNRollState(locationKey, "featureFiles", data);

  return updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", updatedPlaywrightCSharpReqNRoll);
}

export const setPageDOMState = (locationKey, data) => {
  const updatedPlaywrightCSharpReqNRoll = getUpdatedPlaywrightCSharpReqNRollState(locationKey, "pageDOM", data);

  return updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", updatedPlaywrightCSharpReqNRoll);
}

export const setLocatorsState = (locationKey, data) => {
  const updatedPlaywrightCSharpReqNRoll = getUpdatedPlaywrightCSharpReqNRollState(locationKey, "locators", data);

  return updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", updatedPlaywrightCSharpReqNRoll);
}

export const setPageClassState = (locationKey, data) => {
  const updatedPlaywrightCSharpReqNRoll = getUpdatedPlaywrightCSharpReqNRollState(locationKey, "pageClass", data);

  return updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", updatedPlaywrightCSharpReqNRoll);
}

export const setUploadedTestDataState = (locationKey, data) => {
  const updatedPlaywrightCSharpReqNRoll = getUpdatedPlaywrightCSharpReqNRollState(locationKey, "uploadedTestData", data);

  return updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", updatedPlaywrightCSharpReqNRoll);
}

export const setStepDefinitionState = (locationKey, data) => {
  const updatedPlaywrightCSharpReqNRoll = getUpdatedPlaywrightCSharpReqNRollState(locationKey, "stepDefinition", data);

  return updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", updatedPlaywrightCSharpReqNRoll);
}

export const setProjectDataState = (locationKey, data) => {
  const updatedPlaywrightCSharpReqNRoll = getUpdatedPlaywrightCSharpReqNRollState(locationKey, "projectData", data);

  return updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", updatedPlaywrightCSharpReqNRoll);
}

export const setCurrentStepState = (locationKey, data) => {
  const updatedPlaywrightCSharpReqNRoll = getUpdatedPlaywrightCSharpReqNRollState(locationKey, "currentStep", data);

  return updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", updatedPlaywrightCSharpReqNRoll);
}

export const setIsLoadingState = (locationKey, data) => {
  const updatedPlaywrightCSharpReqNRoll = getUpdatedPlaywrightCSharpReqNRollState(locationKey, "isLoading", data);

  return updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", updatedPlaywrightCSharpReqNRoll);
}

export const setErrorState = (locationKey, data) => {
  const updatedPlaywrightCSharpReqNRoll = getUpdatedPlaywrightCSharpReqNRollState(locationKey, "error", data);

  return updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", updatedPlaywrightCSharpReqNRoll);
}

export const resetPlaywrightCSharpReqNRoll = (locationKey) => updateWebAutomation(locationKey, "playwrightCSharpReqNRoll", initialPlaywrightCSharpReqNRollState);